import React from "react";

const WeeklyLog = ({ currentDayNumber, startDate, logData }) => {
  return (
    <div className="weekly-log tw-bg-white  dark:tw-bg-black tw-p-6 tw-rounded-2xl tw-shadow-sm">
      <h2 className="tw-font-semibold tw-mb-4 tw-flex tw-justify-between tw-w-full dark:tw-text-white">
        <span>Week {Math.floor((currentDayNumber - 1) / 7) + 1}</span>
        <span>{currentDayNumber} / 30</span>
      </h2>
      <div className="tw-grid tw-grid-cols-7 tw-gap-8  tw-items-end tw-px-2">
        {(() => {
          let rawDate = startDate;

          if (!rawDate) {
            const firstDay = Object.values(logData)[0];
            if (firstDay?.date) {
              rawDate = firstDay.date;
            } else {
              rawDate = new Date().toISOString().split("T")[0];
            }
          }

          const [year, month, day] = rawDate.split("-").map(Number);
          const trackingStartDate = new Date(year, month - 1, day);

          const startOfWeek = new Date(trackingStartDate);

          startOfWeek.setDate(
            trackingStartDate.getDate() +
              Math.floor((currentDayNumber - 1) / 7) * 7
          );

          return Array.from({ length: 7 })
            .map((_, i) => {
              const d = new Date(startOfWeek);
              d.setDate(d.getDate() + i);

              const dayKey = `Day ${
                Math.floor((d - trackingStartDate) / (1000 * 60 * 60 * 24)) + 1
              }`;
              const dayEntries = logData[dayKey]?.entries || {};
              const hasAnyValue = Object.values(dayEntries).some((meal) =>
                Object.values(meal).some((field) => {
                  if (Array.isArray(field)) return field.length > 0;
                  if (typeof field === "object")
                    return Object.values(field).some((v) => v && v.length > 0);
                  return !!field;
                })
              );
              const total = hasAnyValue;

              return {
                day: (
                  <>
                    <span
                      className="tw-flex tw-items-center tw-justify-center"
                      style={{ fontSize: "0.75em" }}
                    >
                      {d.getMonth() + 1}
                      <span>/</span>
                      {d.getDate()}
                    </span>
                  </>
                ),
                value: total,
              };
            })
            .map(({ day, value }, idx) => (
              <div
                key={idx}
                className="tw-flex tw-flex-col tw-items-center tw-justify-end tw-h-full"
              >
                <div className="tw-relative tw-h-full tw-w-full tw-h-6 tw-min-w-6 tw-flex tw-items-end">
                  <div className="tw-bg-gray-200 tw-rounded-full tw-w-full tw-h-full tw-overflow-hidden tw-flex tw-items-end">
                    <div
                      className="tw-bg-blue-500 tw-rounded-full tw-w-full"
                      style={{
                        height: value ? "100%" : "0%",
                      }}
                    >
                      &nbsp;
                    </div>
                  </div>
                </div>
                <span className="tw-mt-2 tw-flex tw-items-center tw-justify-center">
                  {day}
                </span>
              </div>
            ));
        })()}
      </div>
    </div>
  );
};

export default WeeklyLog;
